/**
 * `normalizeDigits` — fold Arabic-Indic and Eastern Arabic-Indic numerals (and
 * the Arabic decimal separator) down to the ASCII forms `Number()` understands.
 *
 * An Arabic keyboard produces ٠-٩ (U+0660..U+0669); Persian/Urdu layouts
 * produce ۰-۹ (U+06F0..U+06F9). `Number("٣")` is `NaN` and `/^\d+$/` rejects
 * it, so a number typed the way half this product's users type it reads as
 * empty or invalid. Run every numeric free-text field through this before
 * validating or converting it.
 *
 * Also folds the Arabic decimal separator ٫ (U+066B) to `.` and drops the
 * Arabic thousands separator ٬ (U+066C), which appears in pasted values.
 */
const ARABIC_INDIC_ZERO = 0x0660;
const EASTERN_ARABIC_INDIC_ZERO = 0x06f0;

export function normalizeDigits(value: string): string {
  let out = "";
  for (const ch of value) {
    const code = ch.codePointAt(0) ?? 0;
    if (code >= ARABIC_INDIC_ZERO && code <= ARABIC_INDIC_ZERO + 9) {
      out += String(code - ARABIC_INDIC_ZERO);
    } else if (code >= EASTERN_ARABIC_INDIC_ZERO && code <= EASTERN_ARABIC_INDIC_ZERO + 9) {
      out += String(code - EASTERN_ARABIC_INDIC_ZERO);
    } else if (ch === "٫") {
      out += ".";
    } else if (ch === "٬") {
      // Thousands separator — carries no value, and would make Number() NaN.
      continue;
    } else {
      out += ch;
    }
  }
  return out;
}
